"use client";
import { jsx } from "react/jsx-runtime";
import Icon from "../../graphics/Icon/Icon.js";
import { sharedHandler } from "../../../shared/sharedHandler/sharedHandler.js";
import { rem, Box } from "@mantine/core";
import { forwardRef } from "react";
import '../../../assets/IconButton.css';const root = "_root_fhv8j_2";
const IconButtonStyles = {
  root
};
const _IconButton = forwardRef((props, ref) => {
  const {
    icon,
    variant = "default",
    className,
    size = "lg",
    circular,
    loading,
    disabled,
    style,
    mod,
    ariaLabel,
    ...rest
  } = props;
  const getIconColor = () => {
    switch (variant) {
      case "outline":
        return "dark";
      case "light":
      case "transparent":
        return "black";
      default:
        return "light";
    }
  };
  const styleVariables = {
    "--passed-size": size === "sm" ? rem("16px") : size === "md" ? rem("32px") : rem("50px")
  };
  return /* @__PURE__ */ jsx(
    Box,
    {
      ...rest,
      ref,
      className: `${IconButtonStyles.root} ${className}`,
      mod: { variant, circular, loading, disabled, ...mod },
      style: { ...styleVariables, ...style },
      children: /* @__PURE__ */ jsx(Icon, { name: icon, color: getIconColor(), ariaLabel })
    }
  );
});
_IconButton.displayName = "IconButton";
const IconButton = sharedHandler(_IconButton);
IconButton.displayName = _IconButton.displayName;
export {
  IconButtonStyles as I,
  IconButton as default
};
